import { Skeleton as DigdirSkeleton, } from "@digdir/designsystemet-react";
const Skeleton = DigdirSkeleton;
Skeleton.displayName = "Skeleton";
export { Skeleton };
//# sourceMappingURL=skeleton.js.map